import { QueryRef, useQueryRefHandlers, useReadQuery } from '@apollo/client';
import { useLoaderData } from 'react-router-dom';

export const useQueryLoader = <TData>() => {
  const queryRef = useLoaderData() as QueryRef<TData>;
  if (!queryRef) {
    throw new Error(
      'useQueryLoader must be used within a route that has a query loader. Did you forget to export the loader?'
    );
  }
  const { data, error, networkStatus } = useReadQuery(queryRef);
  const { refetch, fetchMore, subscribeToMore } = useQueryRefHandlers(queryRef);

  return {
    data,
    error,
    networkStatus,
    refetch,
    fetchMore,
    subscribeToMore,
  };
};
